import React from "react"
import {
    NavButton,
    NavButtonProps
} from "../../../../Common/NavButton/NavButton"
import { routePaths } from "../../../../../Routes"

type CreateFileUrlLinkProps = Omit<NavButtonProps, "to"> & {
    orgUsername: string
}

export const CreateFileUrlLink = (props: CreateFileUrlLinkProps) => (
    <NavButton
        variant="contained"
        color="plain"
        to={routePaths.datasets(props.orgUsername)}
        {...props}
    >
        Create URLs for local files
    </NavButton>
)
